<template>
  <div class="itemCvr">
    <p class="itemImgDf"><img src="https://cdn.sportsstyle.net/img/static/title.png" width="100%" alt="image loading" />
    <div class="imgmain" v-html="mainImg"></div>
    <p class="imgvari">
      <span class="imgvariimg" v-for="vari in imgVari" v-html="vari"></span>
    </p>
    <router-link :to="{ name: 'itemDetail', params: { id: itemId } }" class="itemImgLink" >
      <span class="itmingcvr"></span>
    </router-link>
  </div>
</template>

<script>
import axios from 'axios'
import lazysizes from 'lazysizes'

export default {
  props: ['itemId'],
  data () {
    return {
      mainImg: '',
      imgVari: '',
    }
  },
  created () {
    this.setupPage(this.$route)
  },
  methods: {
    setupPage() {
      // Loading
      axios.get('https://app3.sportsstyle.net/items/' + this.itemId + "/imgs.json")
      .then((res) => {
        this.mainImg = res.data.mainImg
        this.imgVari = res.data.S
      })
      // .catch(() =>{
      //   console.log('img not found')
      // })
    },
  }
}
</script>
